import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { ALL_UI_IDS } from '../constants';
var disableCaller = [];
export var setAllUIAriaHidden = function setAllUIAriaHidden(caller) {
  var disabled = false;
  ALL_UI_IDS.forEach(function (id) {
    var el = document.getElementById(id);

    if (el) {
      disabled = true;
      el.setAttribute('aria-hidden', 'true');
    }
  });
  if (disabled && !disableCaller.includes(caller)) disableCaller = [].concat(_toConsumableArray(disableCaller), [caller]);
};
export var restoreAllUIAriaHidden = function restoreAllUIAriaHidden(caller) {
  if (disableCaller.length === 0) return;
  if (disableCaller.includes(caller)) disableCaller = disableCaller.filter(function (id) {
    return id !== caller;
  });

  if (disableCaller.length === 0) {
    ALL_UI_IDS.forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.removeAttribute('aria-hidden');
    });
  }
};